import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseAlert",
  props: {
    //useful if needed only a text inside the alert
    text: {
      type: String,
      "default": ""
    },
    alrtClass: {
      type: String,
      "default": ""
    }
  }
});